import { Star } from "lucide-react";
import AppCard from "../../components/AppCard";
import Badge from "../../components/ui/Badge";
import Button from "../../components/ui/Button";
import { useDemo } from "../../providers/DemoProvider";
import { formatDateTime } from "../../services/demoSelectors";

export default () => {
  const { state } = useDemo();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-slate-900">Vault</h2>
          <p className="text-xs font-semibold text-slate-400">Strategic Session Extracts</p>
        </div>
        <Badge tone="info" label={`${state.favorites.length} Entries`} />
      </div>

      {state.favorites.length === 0 && (
        <div className="flex h-64 flex-col items-center justify-center rounded-3xl border border-dashed border-slate-200 bg-white text-center">
          <Star className="mb-4 h-12 w-12 text-slate-100" />
          <p className="text-xs font-semibold text-slate-400">No extracts stored in repository</p>
        </div>
      )}

      <div className="grid gap-6">
        {state.favorites.map(item => (
          <AppCard key={item.id} className="transition-shadow hover:shadow-lg">
            <div className="flex gap-6">
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-amber-100 bg-amber-50 text-amber-500 shadow-sm">
                <Star className="h-5 w-5 fill-amber-500" />
              </div>
              <div className="flex-1 space-y-4">
                <div>
                  <p className="text-xs font-semibold text-slate-400">Context Source</p>
                  <p className="mt-1 font-bold text-slate-800">{item.prompt}</p>
                </div>
                <div className="prose prose-slate prose-sm whitespace-pre-wrap font-medium leading-relaxed text-slate-600">{item.response}</div>
                <div className="flex items-center justify-between border-t border-slate-50 pt-4">
                  <span className="text-xs font-semibold text-slate-400">Timestamp: {formatDateTime(item.createdAt)}</span>
                  <Button variant="ghost" size="sm" className="text-xs font-bold text-rose-500 hover:bg-rose-50">Purge Entry</Button>
                </div>
              </div>
            </div>
          </AppCard>
        ))}
      </div>
    </div>
  );
};
